import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import * as Sentry from "@sentry/react";

import awsExports from "@config/aws";

import { Amplify } from "aws-amplify";

import { ToastProvider } from "@contexts/toast";
import { TitleProvider } from "@contexts/title.context";

import { SENTRY_DSN } from "@config/sentry";
import { PostHogProviderLayout } from "@layouts/posthog-wrapper";
import RoutesData from "./routes-data";

import { BrowserRouter } from "react-router-dom";
import { Loader } from "@components/loader";
import { VersionProvider } from "@contexts/version.context";
import { WebSocketProvider } from "@contexts/web-socket.context";

Sentry.init({
  dsn: SENTRY_DSN,
  enabled: process.env.NODE_ENV === "production",
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [/^https:\/\/(app|dev)\.unifylist\.com/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

Amplify.configure(awsExports);

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <PostHogProviderLayout>
      <TitleProvider>
        <ToastProvider>
          <WebSocketProvider>
            <VersionProvider>
              <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
                <Suspense fallback={<Loader />}>
                  <RoutesData />
                </Suspense>
              </BrowserRouter>
            </VersionProvider>
          </WebSocketProvider>
        </ToastProvider>
      </TitleProvider>
    </PostHogProviderLayout>
  </React.StrictMode>,
);
